import { useParams } from 'react-router-dom'

export const useOrgSlug = (): string | undefined => {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  return orgSlug
}

export const useOrgPath = (path: string): string => {
  const orgSlug = useOrgSlug()

  if (!orgSlug) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (normalizedPath.startsWith(`/${orgSlug}`)) {
    return normalizedPath
  }

  return `/${orgSlug}${normalizedPath}`
}
